import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
export function TestimonialsSection() {
  const testimonials = [{
    result: '-15 cm',
    quote: 'Me sentí más liviana en pocas semanas. Bajó la hinchazón de la tarde y dejé de llegar a la noche con antojos.',
    name: 'Carmen M.',
    age: '44 años',
    country: 'México'
  }, {
    result: '-12 cm',
    quote: 'Volví a tener energía sin vivir a café y fuerza de voluntad. Noté cambios reales en la cintura.',
    name: 'Sofía R.',
    age: '39 años',
    country: 'Colombia'
  }, {
    result: '-14 cm',
    quote: 'Necesitaba algo simple que pudiera sostener. Me desinflamé y volví a notar cambios reales en la ropa.',
    name: 'Ana L.',
    age: '47 años',
    country: 'Argentina'
  }];
  return <section className="bg-gradient-section py-12 md:py-16 px-4 md:px-8" data-id="element-221">
      <div className="max-w-[1400px] mx-auto space-y-16" data-id="element-222">
        {/* Header */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center space-y-4" data-id="element-223">
          <p className="text-secondary font-bold uppercase tracking-wider text-sm" data-id="element-224">
            Lo que cuentan mujeres que hicieron H.E.R.
          </p>
          <h2 className="text-4xl md:text-5xl font-display font-black" data-id="element-225">
            Resultados <span className="text-gradient-gold" data-id="element-226">Reales</span>
          </h2>
        </motion.div>

        {/* Testimonials Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto" data-id="element-227">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: i * 0.2
        }} className="card-premium p-6 md:p-8 relative hover:border-gold/40 transition-colors duration-300 mt-4 md:mt-0" data-id="element-228">
              <div className="space-y-6" data-id="element-229">
                {/* Stars */}
                <div className="flex gap-1" data-id="element-230">
                  {[...Array(5)].map((_, j) => <StarIcon key={j} className="w-5 h-5 text-secondary fill-secondary" data-id="element-231" />)}
                </div>

                {/* Quote */}
                <p className="text-foreground/90 font-body font-medium italic text-base md:text-lg leading-relaxed" data-id="element-232">
                  "{t.quote}"
                </p>

                {/* Author Info */}
                <div className="pt-4 border-t border-border/50" data-id="element-233">
                  <p className="font-display font-bold text-lg text-gold-light" data-id="element-234">
                    {t.name}
                  </p>
                  <p className="text-sm text-foreground/60 font-body mt-1" data-id="element-235">
                    {t.age} • {t.country}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}